export default __webpack_public_path__ + "3aae54b.png";